export default "data:image/gif;base64,R0lGODlhFQAEAHAAACH5BAEAAAIALAAAAAAVAAQAgQAAACMtMAAAAAAAAAINlB+pce24nmxqWsNuAQA7"